(() => {
  const config = window.kuddyDeferredUi || {};
  const state = { cart: false, cartDrawer: false };
  let cartReadyPromise = null;

  const loadStylesheet = (href) => {
    if (!href || document.querySelector(`link[data-kuddy-deferred="${href}"]`)) return;
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = href;
    link.dataset.kuddyDeferred = href;
    document.head.appendChild(link);
  };

  const loadScript = (src, { module = false } = {}) => new Promise((resolve, reject) => {
    if (!src) return resolve();
    const existing = document.querySelector(`script[data-kuddy-deferred="${src}"]`);
    if (existing) {
      if (existing.dataset.kuddyLoaded === 'true') return resolve();
      existing.addEventListener('load', () => resolve(), { once: true });
      existing.addEventListener('error', () => reject(new Error(`Failed to load ${src}`)), { once: true });
      return;
    }
    const script = document.createElement('script');
    script.src = src;
    script.dataset.kuddyDeferred = src;
    if (module) {
      script.type = 'module';
      script.crossOrigin = 'anonymous';
    } else {
      script.defer = true;
    }
    script.onload = () => {
      script.dataset.kuddyLoaded = 'true';
      resolve();
    };
    script.onerror = () => reject(new Error(`Failed to load ${src}`));
    document.head.appendChild(script);
  });

  const loadCartDrawerAssets = async () => {
    if (state.cartDrawer) return;
    state.cartDrawer = true;
    loadStylesheet(config.cartDrawerCss);
    await loadScript(config.cartDrawerJs, { module: true });
  };

  const loadCartAssets = async () => {
    if (state.cart) return cartReadyPromise;
    state.cart = true;
    cartReadyPromise = (async () => {
      await loadCartDrawerAssets();
      await loadScript(config.cartJs);
    })();
    return cartReadyPromise;
  };

  const ensureCart = () => {
    if (!cartReadyPromise) {
      cartReadyPromise = loadCartAssets().catch(() => {
        state.cart = false;
        cartReadyPromise = null;
      });
    }
    return cartReadyPromise;
  };

  const waitUntil = (predicate, timeout = 6000) => new Promise((resolve) => {
    const started = Date.now();
    const check = () => {
      if (predicate()) return resolve(true);
      if (Date.now() - started >= timeout) return resolve(false);
      window.setTimeout(check, 30);
    };
    check();
  });

  const waitForThemeCart = () => waitUntil(() => window.themeCore?.sections?.['cart-drawer']);

  const replayEvent = (name, event) => {
    document.dispatchEvent(new CustomEvent(name, { detail: event.detail }));
  };

  const openAfterAdd = async (sections) => {
    await ensureCart();
    await waitForThemeCart();

    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { sections: sections || null } }));

    const bus = window.themeCore?.EventBus;
    if (bus?.emit) {
      if (sections && Object.keys(sections).length) {
        bus.emit('cart:refresh', sections);
      }
      bus.emit('cart:drawer:open');
    } else {
      document.dispatchEvent(new CustomEvent('cart:open', { detail: { sections: sections || null } }));
      document.querySelector('[data-target="CartDrawer"][data-js-toggle="CartDrawer"]')?.click();
    }

    window.KuddyCart?.bootRecommendations?.();
  };

  document.addEventListener('cart:open', (event) => {
    if (state.cart) return;
    event.stopImmediatePropagation();
    ensureCart().then(() => replayEvent('cart:open', event));
  }, true);

  document.addEventListener('cart:refresh', (event) => {
    if (state.cart) return;
    event.stopImmediatePropagation();
    ensureCart().then(() => replayEvent('cart:refresh', event));
  }, true);

  document.addEventListener('click', (event) => {
    const target = event.target.closest('[data-js-toggle="CartDrawer"], [aria-controls="CartDrawer"], [data-target="CartDrawer"]');
    if (!target || state.cart) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    ensureCart().then(() => target.click());
  }, true);

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.matches('form[action*="/cart/add"], .kuddy-card__form')) return;

    if (form.closest('[data-main-product]')) {
      if (window.__kuddyPdpCartHandler) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      ensureCart().then(async () => {
        await waitUntil(() => window.__kuddyPdpCartHandler, 4000);
        form.requestSubmit();
      });
      return;
    }

    if (state.cart) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    ensureCart().then(() => {
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }, true);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('#CartDrawer [data-cart-fbt-add]');
    if (!button || button.disabled || state.cart) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    ensureCart().then(() => {
      button.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true }));
    });
  }, true);

  if (document.querySelector('[data-main-product]')) {
    const preload = () => { void ensureCart(); };
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', preload, { once: true });
    } else {
      preload();
    }
  }

  window.KuddyDeferredUi = { ensureCart, openAfterAdd, waitForThemeCart };
})();
